import { handleActions } from "redux-actions";
import { UTILITIES } from "constants/action-types";
import { fetchActions, initialBaseState, initialFetchState, updateActions, IFetchStoreState } from "./base-reducers";
import { IUser } from "containers/management/management-types";
import { combineReducers } from "redux";

export interface IAssortmentBuyersState {
    buyers: IFetchStoreState<IUser[]>;
    suggestions: IFetchStoreState<IUser[]>;
}

export const assortmentBuyers = combineReducers<IAssortmentBuyersState>({
    buyers: handleActions<IFetchStoreState<IUser[]>>(
        {
            ...fetchActions(UTILITIES.ASSORTMENT_BUYERS.BUYERS.FETCH),
            ...updateActions(UTILITIES.ASSORTMENT_BUYERS.BUYERS),
        } as any,
        initialBaseState
    ),
    suggestions: handleActions<IFetchStoreState<IUser[]>>(
        {
            ...fetchActions(UTILITIES.ASSORTMENT_BUYERS.SUGGESTIONS.FETCH),
        } as any,
        initialFetchState
    ),
});
